import React from 'react';
import { PageSection, SchoolDescriptionCard } from 'components';
import { CardConfig } from 'components/description-card/DescriptionCard';
import { SCHOOLS_DESCRIPTION_CARDS } from 'consts';
import { useTranslation } from 'react-i18next';
import {
    DescriptionItemsContainer,
    IntroButton,
    SliderContainer,
} from '../../../for-businesses/components/intro/styled';
import { Title } from '../../../for-businesses/components/constructor/styled';
import { SliderStyler } from 'containers/pages/for-businesses/components/courses/styled';
import Slider, { Settings } from 'react-slick';
import {
    DotsContainer,
    DotsList,
} from 'containers/pages/for-businesses/components/reviews/styled';
import {
    ButtonsContainer,
    ContactButton,
    DescriptionContainer,
    DescriptionSubtitle,
} from './styled';
import { sendAnalyticEvent } from 'utils';

const sectionConfig = {
    CWrap: {
        css: {
            position: 'relative',
            color: `#FFF`,
            '&': `:after {
                content: '';
                width: 100%;
                height: 135px;
                position: absolute;
                background: #1d1d1b;
                bottom: 1px;
                transform-origin: left bottom;
                transform: translateY(100%) skewY(3deg);
                border-radius: 0 0 40px 40px;
                z-index: 5;
                @media (max-width: 1023px) {
                    height: 100px;
                }
            }
            `,
        },
    },
    ContentArea: {
        css: {
            paddingTop: 0,
            paddingBottom: 90,
            display: 'block',
            zIndex: 5,

            '@media(max-width: 1279px)': {
                paddingBottom: 20,
            },
        },
    },
};

export const Books = () => {
    const { t } = useTranslation('pages/for-schools-and-colleges');

    const CAROUSEL_SETTINGS: Settings = {
        slidesToScroll: 1,
        infinite: false,
        slidesToShow: 1,
        arrows: false,
        dots: true,
        appendDots: (dots) => (
            <DotsContainer>
                <DotsList> {dots} </DotsList>
            </DotsContainer>
        ),
    };

    return (
        <PageSection config={sectionConfig}>
            <Title>{t(`for-colleges`)}</Title>
            <DescriptionContainer>
                <DescriptionSubtitle>
                    {t('for-colleges-sub')}
                </DescriptionSubtitle>
                <ButtonsContainer>
                    <IntroButton
                        size={'large'}
                        onClick={() => {
                            sendAnalyticEvent('for-colleges_download_find-out');
                            window.open('/assets/files/alliance.pdf', '_blank');
                        }}>
                        {t('know-more')}
                    </IntroButton>
                    <ContactButton
                        size={'large'}
                        variant={'outlined'}
                        color={'secondary'}
                        onClick={() => {
                            window.location.href =
                                'mailto:academy.alliance@kaspersky.com';
                        }}>
                        {t('connect-wth-us')}
                    </ContactButton>
                </ButtonsContainer>
            </DescriptionContainer>
            <DescriptionItemsContainer>
                {SCHOOLS_DESCRIPTION_CARDS.map((item: CardConfig) => (
                    <SchoolDescriptionCard
                        key={item.title}
                        type={'secondary'}
                        config={{
                            ...item,
                            title: t(item.title),
                        }}
                    />
                ))}
            </DescriptionItemsContainer>
            <SliderContainer>
                <SliderStyler>
                    <Slider {...CAROUSEL_SETTINGS}>
                        {SCHOOLS_DESCRIPTION_CARDS.map((item: CardConfig) => (
                            <SchoolDescriptionCard
                                key={item.title}
                                type={'secondary'}
                                config={{
                                    ...item,
                                    title: t(item.title),
                                }}
                            />
                        ))}
                    </Slider>
                </SliderStyler>
            </SliderContainer>
        </PageSection>
    );
};
